var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer"},[_c('div'),_c('div',{staticClass:"answer_content"},[_c('div',{staticClass:"content_list"},[_c('ti',{attrs:{"list_a":_vm.result,"activityid":_vm.activityid},on:{"transfer":_vm.postAnswer}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }